
/**@param {Object} options*/
export function ChiliCommentsBitrixCaptcha (options){

    if(!new.target){
        return new ChiliCommentsBitrixCaptcha(options);
    }

    this.options = options;

    this.options.invisible = false;

    let eventListeners = {};

    this.addEventListener = (event, listener) => {

        if (!eventListeners[event]) {
            eventListeners[event] = [];
        }

        eventListeners[event].push(listener);
    }

    this.emit = (event, data)  => {
        if (eventListeners[event]) {
            eventListeners[event].forEach((listener) => {
                if(typeof listener === "function"){
                    listener(data)
                }
            });
        }
    }

    /**@param {HTMLElement} form*/
    this.render = (form) => {

        let captchaContainer = form.querySelector('.captcha-container');

        if(!captchaContainer.querySelector('input[name=captcha_code]')){
            let captchaCodeInput = document.createElement('input');
            captchaCodeInput.name = 'captcha_code';
            captchaCodeInput.value = this.options.publicKey;
            captchaCodeInput.setAttribute('type', 'hidden');
            captchaContainer.appendChild(captchaCodeInput);
        }
        else{
            let captchaCodeInput = captchaContainer.querySelector('input[name=captcha_code]');
            captchaCodeInput.value = this.options.publicKey;
        }

        if(!captchaContainer.querySelector('input[name=captcha_word]')){
            let captchaWordInput = document.createElement('input');
            captchaWordInput.name = 'captcha_word';
            captchaWordInput.placeholder = BX.message('CHILILAB_COMMENTS_CAPTCHA_CAPTCHA_WORD_INPUT_PLACEHOLDER');
            captchaWordInput.setAttribute('type', 'text');

            captchaWordInput.classList.add('text', 'modality-name');

            captchaContainer.appendChild(captchaWordInput);
        }
        else{
            captchaContainer.querySelector('input[name=captcha_word]').value = '';
        }

        if(!captchaContainer.querySelector('img')){
            let captchaImage = document.createElement('img');
            captchaImage.src = '/bitrix/tools/captcha.php?captcha_code=' + this.options.publicKey;
            captchaImage.alt = 'Captcha image';

            captchaContainer.appendChild(captchaImage);
        }
        else{
            let captchaImage = captchaContainer.querySelector('img');
            captchaImage.src = '/bitrix/tools/captcha.php?captcha_code=' + this.options.publicKey;
        }


        //  <div class="error-message"></div>
        if(!captchaContainer.querySelector('.error-message')){
            let errorMessage = document.createElement('div');
            errorMessage.classList.add('error-message');
            captchaContainer.appendChild(errorMessage);
        }

    };

    /**@param {HTMLElement} form*/
    this.check = (form) => {
        BX.ajax.runAction('chililab:comments.Captcha.check', {
            data: {
                captcha_word: form['captcha_word']?.value,
                captcha_code: form['captcha_code']?.value
            }
        }).then(
            (response)=>{
                if(response.status === 'success'){
                    this.emit('captcha-success', {form: form});
                    this.options.publicKey = response.data?.new_public_key;
                    this.render(form);
                }
                else{
                    this.emit('captcha-error', {errors: response.errors, response: response})
                }
            },
            (response)=>{
                this.emit('captcha-error', {errors: response.errors, response: response});
                this.render(form);
            }
        );
    }

    this.setPublicKey = (publicKey) => {
        this.options.publicKey = publicKey;
    }

    this.isDependedCaptcha = () => {
        return true;
    }

    return this;

}
